module.exports = __webpack_public_path__ + "static/media/AllianceNo2-Regular.1d92e114.woff2";